// CustomerRow.jsx
import React, { useState } from 'react';
import Classes from './Subscriptions.module.css';

import MoreDropDown from './MoreDropDown';
import DropDown from './StatusDropDown/DropDown';

export default function TableRow({ value, index }) {

  return (
    <>
      <div
        className={`${Classes.customerRow} ${value.status === 'disabled' ? Classes.disabledRow : ''
          }`}
        key={value._id}
      >
        <div className={`${Classes.customerInfo} ${Classes.col1}`}>
          <h5>{value.id}</h5>
        </div>

        <div className={`${Classes.bookings} ${Classes.col2}`}>
          <h5>{value.service}</h5>
        </div>

        <div className={`${Classes.dateJoined} ${Classes.col3}`}>
          <h5> {value.started} </h5>
        </div>

        <div className={`${Classes.disableToggle} ${Classes.col4}`}>
          <h5> {value.nextPayment} </h5>
        </div>

        <div className={`${Classes.disableToggle} ${Classes.col5}`}>
          <h5> {value.amount} </h5>
        </div>

        <div className={`${Classes.disableToggle} ${Classes.col6}`}>
          <DropDown
            selectedValue={value.status}
            options={["Active", "Canceled"]}
            onChange={(val) => value.status = val}
            isDropDown={false}
          />
        </div>

        <div className={`${Classes.disableToggle} ${Classes.col7}`}>
          {/* <h5> {value.amount} </h5> */}
          <MoreDropDown
            index={index}
            user={value}
          />
        </div>

        {/* <div className={`${Classes.actions} ${Classes.col8}`}>
        </div> */}
      </div>
    </>
  );
}


